<template>
    <div>
        <van-nav-bar
                title="提货提令列表"
                left-text=""
                left-arrow
                fixed
                @click-left="back()"
                v-if="show"
        />
        <div style="margin-top: 46px">
            <van-search
                    v-model="key"
                    show-action
                    placeholder="提货车号/货主提单号"
                    @search="onSearch"
                    clearable
                    left-icon=""
            >
                <template #action>
                    <div @click="onSearch">
                        <van-icon name="search" size="1.5rem" style="vertical-align: middle"/>
                    </div>
                </template>
            </van-search>
        </div>

        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <van-cell class="swipewarp" @click="showBill(item)" v-for="item in list" :key="item.id" >
                        <van-row gutter="20">
                            <van-col span="14" class="ellipsis">
                                单号：{{item.outnotifyOrderNo}}
                            </van-col>
                            <van-col span="10" class="ellipsisRight">
                                车号：{{item.deliveryVehicleNo}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12" class="ellipsis">
                                日期：{{item.outnotifyDate |moment("YYYY-MM-DD")}}
                            </van-col>
                            <van-col span="12" class="ellipsisRight">
                                提单号：{{item.deliveryNo}}
                            </van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="10" class="ellipsis">
                                仓库：{{item.wcode}}
                            </van-col>
                            <van-col span="14" class="ellipsisRight">
                                创建人：{{item.createPersonName}}
                                <!--货品：{{item.cargoName}}/{{item.amount}}件/{{item.weight}}吨-->
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
        </div>




        <div class="van-address-list__bottom">
            <van-button block  type="info" native-type="submit" class="button" @click="showNew(true)">
                新建
            </van-button>
        </div>

        <van-popup v-model="detailPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
                <van-nav-bar
                        title="提货提令详情"
                        left-text=""
                        left-arrow
                        fixed
                        @click-left="showDetail(false)"
                        v-if="show"
                />

                <div  style="height:calc(100vh - 96px); overflow: auto;margin-top: 46px">
                    <van-pull-refresh  @refresh="onRefresh">
                        <van-list>
                            <div class="van-doc-demo-block">
                                <van-row>
                                    <van-col span="10"><h2 class="van-doc-demo-block__title">{{order.outnotifyOrderNo}}</h2></van-col>
                                    <van-col span="14"><h2 class="van-doc-demo-block__title" style="text-align: right">
                                        {{order.status |statusC}}
                                    </h2></van-col>
                                </van-row>
                                <div class="van-cell-group van-hairline--bottom">
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>提单日期</span></div>
                                        <div class="van-cell__value"><span>  {{order.outnotifyDate | moment("YYYY-MM-DD")}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>货主</span></div>
                                        <div class="van-cell__value"><span>{{order.customerName}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>货主提单号</span></div>
                                        <div class="van-cell__value"><span>{{order.deliveryNo}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>提货车号</span></div>
                                        <div class="van-cell__value"><span>{{order.deliveryVehicleNo}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>提货仓库</span></div>
                                        <div class="van-cell__value"><span>{{order.wcode}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>有效限期</span></div>
                                        <div class="van-cell__value"><span>{{order.effectiveDate |moment("YYYY-MM-DD")}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>备注</span></div>
                                        <div class="van-cell__value"><span>{{order.remarks}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>创建人</span></div>
                                        <div class="van-cell__value"><span>{{order.createPersonName}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>创建时间</span></div>
                                        <!--<div class="van-cell__value"><span>{{order.acceptPersonName}}一一 {{order.acceptTime |moment("YYYY-MM-DD  HH:mm:ss")}}</span></div>-->

                                        <div class="van-cell__value"><span>{{order.createTime |moment("YYYY-MM-DD  HH:mm:ss")}}</span></div>
                                    </div>
                                </div>

                            </div>
                            <div class="van-doc-demo-block">
                                <van-row>
                                    <van-col span="10"><h2 class="van-doc-demo-block__title">提货人信息</h2></van-col>
                                </van-row>
                                <div class="van-cell-group van-hairline--bottom">
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>提货人姓名</span></div>
                                        <div class="van-cell__value"><span>{{order.deliveryName}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>身份证号码</span></div>
                                        <div class="van-cell__value"><span>{{order.deliveryIdnumber}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>手机号码</span></div>
                                        <div class="van-cell__value"><span>{{order.deliveryPhone}}</span></div>
                                    </div>
                                </div>

                            </div>
                            <div class="van-doc-demo-block">
                                <van-row>
                                    <van-col span="10"><h2 class="van-doc-demo-block__title">货品信息</h2></van-col>
                                </van-row>
                                <div class="van-cell-group van-hairline--bottom">
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>品名</span></div>
                                        <div class="van-cell__value"><span>{{order.cargoName}}</span></div>
                                    </div>
                                    <div class="van-cell">
                                        <div class="van-cell__title"><span>数量</span></div>
                                        <div class="van-cell__value"><span>{{order.amount}}件/{{order.weight}}吨</span></div>
                                    </div>
                                </div>

                            </div>
                            <div class="van-doc-demo-block">
                                <van-row>
                                    <van-col span="10"><h2 class="van-doc-demo-block__title">提单照片</h2></van-col>
                                </van-row>

                                <van-grid :border="true" :column-num="3" style="background: #fff">
                                <van-grid-item v-for="item in sampleList" :key="item.id">
                                    <van-image width="100" height="100" lazy-load :src="item.url" @click="showImgAll(item.url)"/>

                                </van-grid-item>
                                </van-grid>

                                <!--<van-grid v-if="list.length>0" :border="true" :column-num="3">-->
                                    <!--<van-grid-item>-->
                                        <!--<van-image width="100" height="100" @click="showImg(item)"/>-->

                                    <!--</van-grid-item>-->
                                    <!--<van-grid-item>-->
                                        <!--<van-image width="100" height="100" @click="showImg(item)"/>-->
                                    <!--</van-grid-item>-->
                                <!--</van-grid>-->

                            </div>
                        </van-list>
                    </van-pull-refresh>
                </div>




                <div class="van-psichase-detail__bottom">
                    <van-button block v-if="outOrderShow"  type="info" native-type="submit" class="button" @click="showdel()">
                        删除
                    </van-button>
                    <van-button block v-if="outOrderShow"  type="info" native-type="submit" class="button" @click="showUpd()">
                        修改
                    </van-button>
                    <van-button block v-if="outOrderShow"  type="info" native-type="submit" class="button" @click="showdaudit()">
                        审核
                    </van-button>
                    <van-button block v-if="outOrderaudit"  type="info" native-type="submit" class="button" @click="showauditCancel()">
                        取消
                    </van-button>
                </div>



        </van-popup>

        <van-popup v-model="newPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
        <van-nav-bar
                title="提货指令新建"
                left-text=""
                left-arrow
                fixed
                @click-left="showNew(false)"
                v-if="show"
        />

        <div  style="height:calc(100vh - 50px); overflow: auto;" class="address">

            <div class="van-doc-demo-block">
                <h2 class="van-doc-demo-block__title">提单指令信息</h2>
                <!--                <div role="separator" class="van-divider van-divider&#45;&#45;hairline"> </div>-->
            </div>


            <van-field  readonly name="picker" :disabled="!isadd" label="提货日期" placeholder="点击选择日期" :value="orderAdd.outnotifyDate"  required
                        @click="showPicker('outnotifyDateMode')"
                        label-width="100px" label-align="right"/>

            <van-field  readonly name="picker" label="有效限期" placeholder="点击选择日期"  :value="orderAdd.effectiveDate"  required
                        @click="showPicker('effectiveDateMode')"
                        label-width="100px" label-align="right"/>



            <van-field  @click="showPicker('showPickerCustomer')" label="货主" :disabled="!isadd" placeholder="请选择货主" autocomplete="off" readonly required
                        label-width="100px" label-align="right"    v-model="customerName">
                <template #button >
                    <van-icon name="arrow"    />
                </template>
            </van-field>
            <van-field  label="货主提单号" placeholder="请输入货主提单号" autocomplete="off" v-model="orderAdd.deliveryNo" required
                        label-width="100px" label-align="right"/>



            <van-field  label="提货仓库" placeholder="请选择仓库" autocomplete="off" v-model="warehouseName" required
                        @click="showPicker('showPickerWarehouse')"
                        label-width="100px" label-align="right">
                <template #button >
                    <van-icon name="arrow" />
                </template>
            </van-field>

            <van-field  label="提货方式" @click="showPicker('showPickerdeliveryMode')" placeholder="请选择提货方式" autocomplete="off" v-model="deliveryModeName" required
                        label-width="100px" label-align="right">
                <template #button >
                    <van-icon name="arrow"   />
                </template>
            </van-field>
            <van-field  label="提货车号" placeholder="请输入车牌号码" autocomplete="off" v-model="orderAdd.deliveryVehicleNo" required
                        label-width="100px" label-align="right"/>
            <van-field  label="提货人姓名" placeholder="请输入提货人姓名" autocomplete="off" v-model="orderAdd.deliveryName"
                        label-width="100px" label-align="right"/>
            <van-field  label="身份证号码" placeholder="请输入身份证号码" autocomplete="off" v-model="orderAdd.deliveryIdnumber"
                        label-width="100px" label-align="right"/>
            <van-field  label="手机号码" placeholder="请输入手机号码" autocomplete="off" v-model="orderAdd.deliveryPhone" required
                        label-width="100px" label-align="right"/>
            <van-field label-align="right" label-width="100px"
                       v-model="orderAdd.remarks"
                       rows="1"
                       autosize="true"
                       label="备注"
                       type="textarea"
                       placeholder="请输入要求"
            />
            <div class="van-doc-demo-block">
                <h2 class="van-doc-demo-block__title">货品信息</h2>
                <!--                <div role="separator" class="van-divider van-divider&#45;&#45;hairline"> </div>-->
            </div>

            <van-field  label="品名" placeholder="请输入品名" autocomplete="off" v-model="orderAdd.cargoName"
                        label-width="100px" label-align="right"/>
            <van-field  label="件数" placeholder="请输入件数" autocomplete="off" v-model="orderAdd.amount"
                        label-width="100px" label-align="right"/>
            <van-field  label="重量" placeholder="请输入重量" autocomplete="off" v-model="orderAdd.weight"
                        label-width="100px" label-align="right"/>


            <div class="van-doc-demo-block">
                <h2 class="van-doc-demo-block__title">原始提单照片</h2>

            </div>
            <div style="background: #fff;padding: 12px">
                <div >

<!--                        <van-image #content-->
<!--                                   width="100%"-->
<!--                                   height="calc(9*100vw/16)"-->
<!--                                   :src="image"-->
<!--                                   @click="() => album()"-->
<!--                        />-->

                    <van-grid :border="true" :column-num="3"  class="psichase-new-pic">
                        <van-grid-item v-for="item in sampleList" :key="item.id">
                            <van-image width="100" height="100" lazy-load :src="item.url" @click="showImgAll(item.url)"/>
                            <div class="van-uploader__preview-delete">
                                <van-icon name="cross" class="badge-icon van-badge--fixed van-badge" @click="delImage(item)" />
                            </div>
                        </van-grid-item>
                        <div class="van-uploader__wrapper" @click="() => album()" style="width: 33.33%;min-height: 116px">
                            <div class="van-uploader__upload" style="width: 100%;height: 100%;">
                                <i class="van-badge__wrapper van-icon van-icon-photograph van-uploader__upload-icon"></i>
                            </div>
                        </div>
                    </van-grid>




                </div>
            </div>
        </div>


            <van-calendar v-model="outnotifyDateMode"
                          :min-date=" new Date()"
                          :default-date="new Date()"
                          type="single" @confirm="calendarConfirm"/>
            <van-calendar v-model="effectiveDateMode"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :default-date="new Date()"
                          type="single" @confirm="calendarConfirmEff"/>

            <van-popup v-model="showPickerCustomer" position="bottom" :style="{ height: '310px' }">
                <van-picker
                        title="货主"
                        show-toolbar
                        :columns="customerIds"
                        @confirm="customerVal"
                        @cancel="showPickerCustomer = false"
                />
            </van-popup>

            <van-popup v-model="showPickerWarehouse" position="bottom" :style="{ height: '310px' }">
                <van-picker
                        title="仓库"
                        show-toolbar
                        :columns="warehouseIds"
                        @confirm="warehouseVal"
                        @cancel="showPickerWarehouse = false"
                />
            </van-popup>

            <van-popup v-model="showPickerdeliveryMode" position="bottom" :style="{ height: '310px' }">
                <van-picker
                        title="提货方式"
                        show-toolbar
                        :columns="deliveryModeIds"
                        @confirm="deliveryModeVal"
                        @cancel="showPickerdeliveryMode = false"
                />
            </van-popup>

        <div class="van-address-list__bottom">
            <van-button block  type="info" native-type="submit" class="button" @click="save()">
                保存
            </van-button>
        </div>


        </van-popup>


    </div>
</template>

<script>
    import Vue from 'vue'
    import { Dialog} from 'vant';
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        uploader,
        Toast
    } from 'vant';
    import service from '../../server/index'
    import {uuid} from 'vue-uuid'; // uuid object is also exported to things
    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    import wx from 'weixin-js-sdk';
    import COS from 'cos-js-sdk-v5'
    var Minio = require('minio')
    const today=new Date()
    const dates = today.getTime() + (2000 * 60 * 60 * 24);
    today.setTime(dates);
    const year=today.getFullYear()
    const month=today.getMonth()
    const day=today.getDate()


    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [uploader.name]: uploader,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                isadd:true,
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                date: '',
                dateFormat: 'YYYY-MM-DD',
                //刷新
                pageSize: 20,
                //日期选择calendarShow
                //详情pop
                detailPop: false,
                newPop: false,
                detailList: [],
                packageList: [],
                packageNo:[],
                key:"",
                page: 1,
                isLoading: false,
                order:{},
                logList:[],
                images:[],
                orderAdd:{outnotifyOrderId:uuid.v1(),

                },
                minDate:new Date(),
                maxDate:new Date(year,month,day),
                outnotifyDateMode:false,
                effectiveDateMode:false,
                showPickerCustomer:false,
                showPickerWarehouse:false,
                showPickerdeliveryMode:false,
                customerIds: [],
                customerData : [],
                customerName:"",
                warehouseName:"",
                warehouseIds:[],
                warehouseData:[],
                deliveryModeName:"",
                deliveryModeIds:['自提','配送'],
                deliveryModeData:[{ deliveryMode:10,deliveryModeName:"自提"},{ deliveryMode:20,deliveryModeName:"配送"}],
                sampleList:[],
                base64List: [require('../../assets/image/addimgbg.jpg'),],
                imageList: [],
                outOrderShow:false,
                outOrderaudit:false,
                minioClient:undefined,



            }
        },
        mounted() {
            this.onLoad();

            let param = {};
            param.ouid = localStorage.getItem("ouid")
            service.selOuCustomerG(param).then(res => {
                let data = res.data;
                this.customerData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.customerIds.push(data[i].orgunitName)
                }

            })
            service.selWarehouseG(param).then(res => {
                let data = res.data;
                this.warehouseData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.warehouseIds.push(data[i].wcode)
                }
            })


        },
        methods: {
            showImgAll(item) {
                ImagePreview([item]);
            },
            delImage(data){

                let outnotifyOrderImageId=data.id
                let param={}
                param.outnotifyOrderImageId=outnotifyOrderImageId
                service.delCrmOutNotifyImageId(param).then((res) => {
                    if (res.code == "200"){

                        this.selOrderImage()


                    }
                })



            },
            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            calendarConfirm(date) {
                this.outnotifyDateMode = false;
                this.orderAdd.outnotifyDate = this.$moment(date).format("YYYY-MM-DD")
                this.orderAdd.effectiveDate= Vue.prototype.$moment(new Date(new Date(date).getTime() + (2000 * 60 * 60 * 24)).toLocaleDateString()).format('YYYY-MM-DD')

                let todays=new Date(date)
                let datess = todays.getTime() + (2000 * 60 * 60 * 24);
                todays.setTime(datess);
                let years=todays.getFullYear()
                let months=todays.getMonth()
                let days=todays.getDate()
                this.maxDate=new Date(years,months,days)
                let tod=new Date(date)
                let years2=tod.getFullYear()
                let months2=tod.getMonth()
                let days2=tod.getDate()
                this.minDate=new Date(years2,months2,days2)
            },
            calendarConfirmEff(date){
                this.effectiveDateMode = false;
                this.orderAdd.effectiveDate = this.$moment(date).format("YYYY-MM-DD")
            },
            customerVal(value, index){
                this.customerName = value;
                this.orderAdd.customerId = this.customerData[index].customerId
                this.showPickerCustomer = false;
            },

            warehouseVal(value, index){
                this.warehouseName = value;
                this.orderAdd.warehouseId = this.warehouseData[index].warehouseId
                this.showPickerWarehouse = false;
            },
            deliveryModeVal(value, index){
                this.deliveryModeName = value;
                this.orderAdd.deliveryMode = this.deliveryModeData[index].deliveryMode
                this.showPickerdeliveryMode = false;
            },
            showPicker(pickerName){
                this.outnotifyDateMode = false
                this.effectiveDateMode=false
                this.showPickerCustomer=false
                this.showPickerWarehouse=false
                this.showPickerdeliveryMode=false
                switch (pickerName) {
                    case 'outnotifyDateMode':
                        this.outnotifyDateMode = true
                        break
                    case 'effectiveDateMode':
                        this.effectiveDateMode = true
                        break
                    case 'showPickerCustomer':
                        this.showPickerCustomer = true
                        break
                    case 'showPickerWarehouse':
                        this.showPickerWarehouse = true
                        break
                    case 'showPickerdeliveryMode':
                        this.showPickerdeliveryMode = true
                        break
                }


            },
            onConfirm(date) {
                this.show = false;
                this.date = this.formatDate(date);
            },
            back() {
                this.$router.replace("/cangAll")
            },
            onRefresh() {
                this.onSearch();

            },
            onSearch() {
                this.list = [];
                this.page = 1;


                this.onLoad();
            },
            showDetail(flag) {
                this.detailPop = flag;
            },
            showNew(flag) {



                this.newPop = flag;
                this.isadd=true
                this.customerName=""
                this.warehouseName=""
                this.deliveryModeName="自提"
                this.orderAdd={outnotifyOrderId:uuid.v1(),deliveryMode:10}
                this.orderAdd.outnotifyDate = this.$moment(new Date()).format("YYYY-MM-DD")
                this.orderAdd.effectiveDate = this.$moment(new Date(new Date().toLocaleDateString()).getTime() + (2000 * 60 * 60 * 24)).format("YYYY-MM-DD")
                this.sampleList=[]

                let data= this.customerData
                if(data !=null && data.length>0)
                {
                    this.orderAdd.customerId=data[0].customerId
                    this.customerName=this.customerIds[0]

                }


            },
            showUpd(){
                this.newPop = true;
                this.isadd=false
                let data=this.order
                data.outnotifyDate=Vue.prototype.$moment(new Date(data.outnotifyDate)).format('YYYY-MM-DD')
                data.effectiveDate=Vue.prototype.$moment(new Date(data.effectiveDate)).format('YYYY-MM-DD')
                this.customerName=this.customerData.filter(function (item) {
                    return data.customerId == item.customerId
                })[0].orgunitName

                this.warehouseName=this.warehouseData.filter(function (item) {
                    return data.warehouseId == item.warehouseId
                })[0].wcode

                this.deliveryModeName=this.deliveryModeData.filter(function (item) {
                    return data.deliveryMode == item.deliveryMode
                })[0].deliveryModeName
                this.orderAdd=data



            },

            showdel(){


                Dialog.confirm({
                    title: '提示消息',
                    message: '确定删除吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.delCrmOutNotify({outnotifyOrderId: this.order.outnotifyOrderId}).then(res => {
                        if (res.code == "200") {
                            Toast("删除成功")
                            this.detailPop = false;
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })


            },
            showdaudit(){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定审核吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.auditCrmOutNotify({outnotifyOrderId: this.order.outnotifyOrderId,appid:localStorage.getItem("appid")}).then(res => {
                        if (res.code == "200") {
                            Toast("审核成功")
                            this.detailPop = false;
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })


            },
            showauditCancel(){

                Dialog.confirm({
                    title: '提示消息',
                    message: '确定取消吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.auditCrmOutNotifyCancel({outnotifyOrderId: this.order.outnotifyOrderId}).then(res => {
                        if (res.code == "200") {
                            Toast("取消成功")
                            this.detailPop = false;
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })


            },


            showBill(data)
            {
                this.sampleList=[]
                let outnotifyOrderId=data.outnotifyOrderId
                let param={}
                param.outnotifyOrderId=outnotifyOrderId

                service.selCrmOutNotifyId(param).then((res) => {
                    if (res.code == "200"){

                        let data = res.data;
                        this.order=data.order
                        let orderImages=data.orderImages

                        this.outOrderShow=false
                        this.outOrderaudit=false
                        if(data.order.status==10)
                        {
                            this.outOrderShow=true
                        }
                        if(data.order.status==20)
                        {
                            this.outOrderaudit=true

                        }

                        let sampleList=[]
                        for (let i=0;i<orderImages.length;i++)
                        {
                            let samplePath = orderImages[i].orderImgUrl
                            service.getPath({key: samplePath}).then(res => {
                                // console.log(res);
                                let images={}
                                images.id=orderImages[i].outnotifyOrderImageId
                                images.url=res.data
                                sampleList.push(images);
                            })

                        }
                        this.sampleList=sampleList


                    }
                })




                this.detailPop = true;
            },
            save() {


                let r = /^\+?[1-9][0-9]*$/;


                if (this.orderAdd.customerId == "" || this.orderAdd.customerId == undefined) {
                    Toast('请指定货主')
                    return
                }

                if (this.orderAdd.deliveryNo == "" || this.orderAdd.deliveryNo == undefined) {
                    Toast('请输入货主提单号')
                    return
                }


                if (this.orderAdd.warehouseId == "" || this.orderAdd.warehouseId == undefined) {
                    Toast('请输入提货仓库')
                    return
                }
                if (this.orderAdd.deliveryMode == "" || this.orderAdd.deliveryMode == undefined) {

                    Toast('请输入提货方式')
                    return
                }
                if (this.orderAdd.deliveryVehicleNo == "" || this.orderAdd.deliveryVehicleNo == undefined) {
                    Toast('请输入提货车号')
                    return
                } else {
                    let express =
                        /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
                    if (!express.test(this.orderAdd.deliveryVehicleNo)) {
                        Toast('请输入正确格式的提货车号')
                        return false;
                    }

                }

                // if (this.orderAdd.deliveryName == "" || this.orderAdd.deliveryName == undefined) {
                //     Toast('请输入提货人姓名')
                //     return
                // }
                if (this.orderAdd.deliveryIdnumber == "" || this.orderAdd.deliveryIdnumber == undefined) {
                    // this.$message.warning("请输入身份证号码")
                    // return
                } else {
                    if (!this.common.isIdnumber(this.orderAdd.deliveryIdnumber)) {
                        Toast('请输入正确格式的身份证号码')
                        return false
                    }

                }

                if (this.orderAdd.deliveryPhone != "" || this.orderAdd.deliveryPhone == undefined) {
                    if (!this.common.isPhone(this.orderAdd.deliveryPhone)) {
                        Toast('请输入正确格式的手机号码')
                        return false
                    }

                }

                if (this.orderAdd.amount != "" && this.orderAdd.amount != undefined) {
                    if (!this.common.isNotANumberNew(this.orderAdd.amount)) {
                        Toast('请输入正确格式的件数')
                        return false
                    }
                    if (parseInt(this.orderAdd.amount) <= 0) {
                        Toast('件数应为大于0的整数')
                        return false

                    }


                    if (!r.test(this.orderAdd.amount)) {
                        Toast('件数应为大于0的整数')
                        return false

                    }
                }


                if (this.orderAdd.weight != "" && this.orderAdd.weight != undefined) {

                    if (!this.common.isNotANumberNew(this.orderAdd.weight)) {
                        Toast('请输入正确格式的重量')
                        return false
                    }
                    if (parseFloat(this.orderAdd.weight) < 0) {
                        Toast('重量应为大于等于0的数字')
                        return false

                    }


                }

                if ((this.orderAdd.warehouseId ==219 && this.sampleList.length==0) ||
                    (this.orderAdd.warehouseId ==220 && this.sampleList.length==0) ||
                    (this.orderAdd.warehouseId ==223 && this.sampleList.length==0) ||
                    (this.orderAdd.warehouseId ==224 && this.sampleList.length==0) ||
                    (this.orderAdd.warehouseId ==226 && this.sampleList.length==0)
                )
                {
                    Toast('请上传原始提单照片')
                    return false
                }



                let  imageList=this.sampleList
                let p=[]
                for (let i=0;i<imageList.length;i++)
                {
                    let o={}
                    o.orderImgUrl=imageList[i].name

                    p.push(o)
                }
                this.orderAdd.imageList=p

                if(this.isadd)
                {
                    let parm=this.orderAdd;


                        parm.outnotifyStr=parm.outnotifyDate


                        parm.effectiveStr=parm.effectiveDate



                    parm.ouid=localStorage.getItem("ouid")
                    service.addCrmOutNotify(parm).then(res=>{
                        console.log(res)
                        if(res.code == "200")
                        {
                            Toast("保存成功")
                            this.newPop = false
                            this.onSearch()

                        }else
                        {
                            Toast("保存失败"+res.data.msg)
                        }


                    })

                }else
                {

                    let parm=this.orderAdd;
                    parm.ouid=localStorage.getItem("ouid")
                    parm.outnotifyStr=parm.outnotifyDate


                    parm.effectiveStr=parm.effectiveDate
                    service.updCrmOutNotify(parm).then(res=>{
                        if(res.code == "200")
                        {
                            Toast("修改成功")
                            this.newPop = false
                            this.onSearch()

                        }else
                        {
                            Toast("修改成功"+res.data.msg)
                        }


                    })


                }

            },
            onLoad() {
                let param = {}
                param.limit = 10
                param.page = this.page
                param.key = this.key
                param.ouid = localStorage.getItem("ouid")
                service.selCrmOutNotifyP(param).then((res) => {
                    if (res.code == "200") {
                        if (res.data != null && res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }

                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                })
            },

            album() {
                    var self = this;
                    let params = {
                        url: window.location.href.split("#")[0],
                        appName: process.env.VUE_APP_NAME,
                        ouid:process.env.VUE_APP_WECHAT_OUID
                    }
                    service.getWxconfig(params).then((res) => {
                        // alert(JSON.stringify(res));
                        if (res.code == 200) {
                            wx.config({
                                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                appId: res.data.appId, // 必填，公众号的唯一标识
                                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                                nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                                signature: res.data.signature,// 必填，签名
                                jsApiList: ['chooseImage'] // 必填，需要使用的JS接口列表
                            });

                            wx.ready(function () {//需在用户可能点击分享按钮前就先调用
                                console.log("do wx ready")
                                wx.chooseImage({
                                    count: 1, // 默认9
                                    sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                                    sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                                    success: function (res) {
                                        var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                                        console.log("localIds", localIds)
                                        self.imageList = localIds;
                                        for (let i = 0; i < localIds.length; i++) {
                                            self.showImg(localIds[i])
                                            console.log("selected img:", localIds[i]);
                                        }
                                    }
                                });
                            });
                            wx.error(function (res) {
                                console.log("wx error:", res)
                                alert(res.errMsg);
                                //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            });
                        }
                    }).catch((res) => {
                        console.log("Catch", res);
                    });

            },
            showImg(id) {
                let self = this;
                console.log("id", id)
                let params = {
                    url: window.location.href.split("#")[0],
                    appName: process.env.VUE_APP_NAME,
                    ouid:process.env.VUE_APP_WECHAT_OUID
                }
                service.getWxconfig(params).then((res) => {
                    // alert(JSON.stringify(res));
                    if (res.code == 200) {
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: res.data.appId, // 必填，公众号的唯一标识
                            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                            signature: res.data.signature,// 必填，签名
                            jsApiList: ['getLocalImgData'] // 必填，需要使用的JS接口列表
                        });
                        wx.ready(function () {//需在用户可能点击分享按钮前就先调用
                            wx.getLocalImgData({
                                localId: id, // 图片的localID
                                success: function (res) {
                                    console.log("localData", res.localData)
                                    if (res.localData.indexOf('data:image') != 0) {
                                        //判断是否有这样的头部
                                        res.localData = 'data:image/jpeg;base64,' + res.localData
                                    }
                                    res.localData = res.localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
                                    self.uploadImg( res.localData);
                                    // return  res.localData; // localData是图片的base64数据，可以用img标签显示
                                }
                            });
                        });
                        wx.error(function (res) {
                            console.log("wx error:", res)
                            alert(res.errMsg);
                            //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                        });
                    }
                }).catch((res) => {
                    console.log("Catch", res);
                });
            },
            uploadImg(localData) {
                // let appid=this.getQueryVariable("appid")
                let appid =localStorage.getItem("appid")
                // let ouid=this.getQueryVariable("ouid")
                let ouid = localStorage.getItem("ouid")
                let folder = "/" + appid + "/" + ouid + "/outOrder/" + Vue.prototype.$moment(new Date()).format('YYYYMM') + "/";


                        let filename = uuid.v1()  + ".jpg";
                        let fileObj = this.dataURLtoFile(localData, filename);
                        let url = process.env.VUE_APP_API;
                        let serveName = process.env.VUE_APP_NAME;
                        let thirdApp = process.env.VUE_APP_THIRDAPP_USERNAME;
                        let thirdPWD = process.env.VUE_APP_THIRDAPP_PASSWORD;
                let origin = localStorage.getItem("upo")
                if(origin==="t"){
                    service.getAuthentication(url + serveName, "", {
                        username: thirdApp,
                        password: thirdPWD
                    }).then(auth => {
                        if (auth.code == 200) {
                            this.tmpToken = auth.data;
                            service.getCosCredential(url + serveName, auth.data, {}).then(res => {
                                this.uploadFile(res.data, folder, fileObj, filename);
                                service.killAuthentication(url + serveName, this.tmpToken, {}).then(kill => {
                                    console.log("kill", kill)
                                })
                            })
                        } else {
                            Toast(auth.msg)
                        }
                    })
                }
                else if(origin==="m"){
                    this.minioClient = new Minio.Client({
                        endPoint:  localStorage.getItem("endpoint"),
                        port: parseInt(localStorage.getItem("port")),
                        useSSL: true,
                        accessKey: localStorage.getItem("ytoken"),
                        secretKey: localStorage.getItem("ztoken")
                    });
                    this.uploadMinIOFile( localStorage.getItem("bucket"),folder, fileObj, filename);

                }


                    // alert("现在有"+this.base64List.length+"张图片")

            },

            uploadFile(sign, folder, file, filename) {
                let _this = this
                // console.log("file",file)
                var bucket = process.env.VUE_APP_COS_BUCKET;
                var region = 'ap-shanghai';
                // var _this = this;
                var cos = new COS({
                    // 必选参数
                    getAuthorization: function (options, callback) {
                        callback({
                            TmpSecretId: sign.tmpSecretId,
                            TmpSecretKey: sign.tmpSecretKey,
                            XCosSecurityToken: sign.sessionToken,
                            StartTime: sign.startTime, // 时间戳，单位秒，如：1580000000
                            ExpiredTime: sign.expiredTime, // 时间戳，单位秒，如：1580000900
                        });
                    },
                });
                cos.putObject({
                        Bucket: bucket,
                        Region: region,
                        Key: folder + filename,
                        StorageClass: 'STANDARD',
                        Body: file,
                        onProgress: function (progressData) {
                            console.log(JSON.stringify(progressData));
                        }
                    },
                    function () {
                        let outnotifyOrderId = _this.orderAdd.outnotifyOrderId
                        let samplePath = folder + filename;
                        let url = process.env.VUE_APP_API;
                        let serveName = process.env.VUE_APP_NAME;
                        let topicIs =  1
                        service.addOutOrderImageG(url + serveName, {
                            topicIs:topicIs,
                            outnotifyOrderId: outnotifyOrderId,
                            orderImgUrl: samplePath
                        }).then((res) => {
                            if (res.code == "200") {
                                Toast("图片上传成功");

                                _this.selOrderImage()

                            } else {
                                Toast("图片上传失败");
                            }
                        });

                    });
            },
            uploadMinIOFile(bucket,folder, file, filename) {
                let fr = new FileReader();//用FileReader 读取文件流
                fr.readAsArrayBuffer(file);
                fr.addEventListener("loadend",e=>{
                    //e.target.result 就是读取到的文件流 将其转为Buffer类型即可
                    let _this = this;

                    this.minioClient.putObject(bucket, folder+filename, new Buffer(e.target.result), file.size, function(err, objInfo) {
                        if(err) {
                            return console.log(err); // err should be null
                        }
                        console.log(objInfo)
                        let outnotifyOrderId = _this.orderAdd.outnotifyOrderId
                        let samplePath = folder + filename;
                        let url = process.env.VUE_APP_API;
                        let serveName = process.env.VUE_APP_NAME;
                        let topicIs =  1
                        service.addOutOrderImageG(url + serveName, {
                            topicIs:topicIs,
                            outnotifyOrderId: outnotifyOrderId,
                            orderImgUrl: samplePath
                        }).then((res) => {
                            if (res.code == "200") {
                                Toast("图片上传成功");

                                _this.selOrderImage()

                            } else {
                                Toast("图片上传失败");
                            }
                        });

                    })
                })
            },
            selOrderImage(){

                let _this=this
                let parm = {};
                parm.outnotifyOrderId = _this.orderAdd.outnotifyOrderId
                service.selCrmOutNotifyImageId(parm).then(res => {


                    let orderImages=res.data.orderImages
                    console.log(orderImages)

                    _this.sampleList=[]
                    let sampleList=[]
                    for (let i=0;i<orderImages.length;i++)
                    {
                        let samplePath = orderImages[i].orderImgUrl
                        service.getPath({key: samplePath}).then(res => {
                            // console.log(res);
                            let images={}
                            images.id=orderImages[i].outnotifyOrderImageId
                            images.url=res.data
                            sampleList.push(images);
                        })

                    }
                    this.sampleList=sampleList

                    // alert(details)




                })


            },

            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type: mime});
            }

        },
        filters:{

            statusC: function (value) {
                if(value == 10)
                {
                    return '待审核'
                }
                if(value ==20)
                {
                    return '已审核'
                }
                if(value == 100)
                {
                    return '已完成'
                }

            },



        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .contentwarp {
        margin-top: 0px;
        height: calc(100vh - 204px);
        overflow: auto;
        /*height: 550px;*/
    }
    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }

    /*/deep/ .van-cell__title {*/
    /*    text-align: left;*/
    /*    -webkit-box-flex: unset;*/
    /*    -webkit-flex: unset;*/
    /*    flex: unset;*/
    /*}*/
    .van-panel__content{
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }
    .searchwarp .van-hairline--top-bottom::after {
        border-width:0;
    }
    .van-panel__content dd{
        margin-inline-start: 0px;
        font-size: 14px;
    }
    .van-panel__content dt{
        font-size: 14px;
        font-weight: bold;
    }
    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 15px;
        line-height: 16px;
        text-align: left;
    }
    /deep/ .van-cell__title{
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex:unset;
        flex:unset;
        width: 90px;
        color: #969799;
    }
    /deep/ .van-cell__value{
        color: #323233;
    }
    .van-list .van-cell-group::after {
        border-bottom-width: 5px;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right{
        text-align: right;
    }
    .van-psichase-detail__bottom{
        display:-webkit-box;
    }
    .van-psichase-detail__bottom .button{
        -webkit-box-flex:1;
    }
    /deep/ .psichase-new-pic .van-image{
        position: relative;
    }
    .van-uploader__preview-delete {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: rgba(0,0,0,.7);
        border-radius: 0 0 0 12px;
    }
    /deep/ .psichase-new-pic .van-icon.van-icon-cross{
  position: absolute;
        top:0;
        right: 0;
        color: #fff;
        font-size: 16px;
        transform: scale(.7) translate(10%,-10%);
    }
    /deep/ .van-grid-item__content{
        padding: 8px;
    }
    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }
    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 50px;
        border: 1px solid white;
    }
    /deep/ .van-cell__title.van-field__label.van-field__label--right {
        text-align: left;
    }
    /deep/ .address .van-cell {
        padding: 8px 16px 8px 20px;
    }
    .van-cell{
        padding: 8px 16px;
        font-size: 15px;
    }
    /deep/ .van-cell .van-field__control{
        font-size: 15px;
    }
</style>
